import type { ReactNode } from "react";

export const HaNTabsBar = ({ children }: { children: ReactNode }) => {
  return (
    <div className="col-start-1 row-start-3 border-b border-r bg-white empty:hidden max-sm:border-r-0">{children}</div>
  );
};
